import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Sign from '../views/Sign';
import Bonus from '../views/Bonus';

export default new Router({
    mode: 'hash', //history
    routes: [{
        path: '/',
        redirect: '/sign',
        name: 'index'
    }, {
        path: '/sign',
        component: Sign,
        name: 'sign'
    }, {
        path: '/bonus',
        component: Bonus,
        name: 'bonus'
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js